var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArroWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.40625C5.59375 9.53125 5.375 9.53125 5.21875 9.40625L1.09375 5.28125C0.96875 5.125 0.96875 4.90625 1.09375 4.75L5.21875 0.625C5.375 0.5 5.59375 0.5 5.75 0.625L6.375 1.25C6.5 1.40625 6.5 1.625 6.34375 1.78125L3.84375 4.1875H14.625C14.8125 4.1875 15 4.375 15 4.5625V5.4375C15 5.65625 14.8125 5.8125 14.625 5.8125H3.84375L6.34375 8.25C6.5 8.40625 6.5 8.625 6.375 8.78125L5.75 9.40625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArroWhite);
export default __webpack_public_path__ + "static/media/arroWhite.e9c56489868e597cde1d787fc606e04a.svg";
export { ForwardRef as ReactComponent };